import generateBcomUrl from '@resources/js/helpers/generateBcomUrl'
import generateExpediaUrl from '@resources/js/helpers/generateExpediaUrl'
import generateHouseSitterUrl from '@resources/js/helpers/generateHouseSitterUrl'

export const PROMOTION_TYPES = {
	bcom: {
		generateLink: generateBcomUrl,
	},

	expedia: {
		generateLink: generateExpediaUrl,
	},

	housesitter: {
		generateLink: generateHouseSitterUrl,
	},
}

export const DEFAULT_PROMOTION_ACTIONS = {
	links: {
		active: false,
		type: 'bcom',
		init: async (...options) => {
			const { default: initComponent } = await import(
				'@resources/js/components/promotion/initLinks'
			)
			initComponent(...options)
		},
	},
	backbtn: {
		active: false,
		type: 'bcom',
		init: async (...options) => {
			const { default: initComponent } = await import(
				'@resources/js/components/promotion/initBackBtn'
			)
			initComponent(...options)
		},
	},
	tab_change: {
		active: false,
		type: 'bcom',
		init: async (...options) => {
			const { default: initComponent } = await import(
				'@resources/js/components/promotion/initTabChange'
			)
			initComponent(...options)
		},
	},
	popup: {
		active: false,
		type: 'bcom',
		init: async (...options) => {
			const { default: initComponent } = await import(
				'@resources/js/components/promotion/initExitPopup'
			)
			initComponent(...options)
		},
	},
	housesitter: {
		active: false,
		type: 'housesitter',
		init: async (...options) => {
			const { default: initComponent } = await import(
				'@resources/js/components/promotion/initHouseSitter'
			)
			initComponent(...options)
		},
	},
}
